import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    main: {
      padding: '1.4rem'
    },
    headerTitle: {
      height: '40px',
      marginBottom: '0.5rem'
    },
    headerSubtitle: {
      height: '20px'
    }
  },
  filter: {
    height: '40px',
    marginTop: '1.5rem'
  },
  AccordionHeading: {
    height: '40px',
    marginTop: '1.5rem'
  },
  list: {
    marginTop: '1.5rem'
  },
  subtitle: {
    height: '20px',
    marginTop: '1.0rem'
  },
  fareItem: {
    main: {
      marginBottom: '1.5rem'
    },
    box: {},
    body: { padding: '1.0rem', height: '100px' },
    image: {
      height: '140px',
      marginBottom: '0.5rem'
    },
    title: {
      height: '20px',
      marginBottom: '1rem'
    },
    subtitle: {
      height: '20px'
    },
    button: {
      height: '40px',
      float: 'right'
    }
  },

  loadMore: {
    main: {
      display: 'flex',
      justifyContent: 'center'
    },
    box: {
      width: '200px',
      height: '40px'
    }
  },
  disclaimer: {
    height: '20px',
    marginTop: '1rem'
  }
};

const SkeletonBreakingDeals = (props) => {
  const {
    header,
    filter,
    list,
    subtitle,
    fareItem,
    loadMore,
    AccordionHeading,
    disclaimer
  } = styles;
  const [className, style] = useStyles(props);
  return (
    <Box className={`${className} fr-skeleton`} style={style} dataTestId="skeletonBreakingDeals">
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-box" style={header.main}>
            <Col xs="8" className="fr-skeleton-element" style={header.headerTitle} />
            <Col xs="10" className="fr-skeleton-element" style={header.headerSubtitle} />
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Col xs="5" className="fr-skeleton-element" style={filter} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Col xs="12" className="fr-skeleton-element" style={AccordionHeading} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Col xs="10" className="fr-skeleton-element" style={subtitle} />
        </Col>
      </Row>

      <Row gutters style={list}>
        <Col xs="4" style={fareItem.main}>
          <Box className="fr-skeleton-box fr-clearfix" style={fareItem.box}>
            <Col xs="12" className="fr-skeleton-element" style={fareItem.image} />
            <Box className="fr-skeleton-box " style={fareItem.body}>
              <Col xs="6" className="fr-skeleton-element" style={fareItem.title} />
              <Col xs="4" className="fr-skeleton-element" style={fareItem.button} />
            </Box>
          </Box>
        </Col>
        <Col xs="4" style={fareItem.main}>
          <Box className="fr-skeleton-box fr-clearfix" style={fareItem.box}>
            <Col xs="12" className="fr-skeleton-element" style={fareItem.image} />
            <Box className="fr-skeleton-box " style={fareItem.body}>
              <Col xs="6" className="fr-skeleton-element" style={fareItem.title} />
              <Col xs="4" className="fr-skeleton-element" style={fareItem.button} />
            </Box>
          </Box>
        </Col>
        <Col xs="4" style={fareItem.main}>
          <Box className="fr-skeleton-box fr-clearfix" style={fareItem.box}>
            <Col xs="12" className="fr-skeleton-element" style={fareItem.image} />
            <Box className="fr-skeleton-box " style={fareItem.body}>
              <Col xs="6" className="fr-skeleton-element" style={fareItem.title} />
              <Col xs="4" className="fr-skeleton-element" style={fareItem.button} />
            </Box>
          </Box>
        </Col>
        <Col xs="4" style={fareItem.main}>
          <Box className="fr-skeleton-box fr-clearfix" style={fareItem.box}>
            <Col xs="12" className="fr-skeleton-element" style={fareItem.image} />
            <Box className="fr-skeleton-box " style={fareItem.body}>
              <Col xs="6" className="fr-skeleton-element" style={fareItem.title} />
              <Col xs="4" className="fr-skeleton-element" style={fareItem.button} />
            </Box>
          </Box>
        </Col>
        <Col xs="4" style={fareItem.main}>
          <Box className="fr-skeleton-box fr-clearfix" style={fareItem.box}>
            <Col xs="12" className="fr-skeleton-element" style={fareItem.image} />
            <Box className="fr-skeleton-box " style={fareItem.body}>
              <Col xs="6" className="fr-skeleton-element" style={fareItem.title} />
              <Col xs="4" className="fr-skeleton-element" style={fareItem.button} />
            </Box>
          </Box>
        </Col>
        <Col xs="4" style={fareItem.main}>
          <Box className="fr-skeleton-box fr-clearfix" style={fareItem.box}>
            <Col xs="12" className="fr-skeleton-element" style={fareItem.image} />
            <Box className="fr-skeleton-box " style={fareItem.body}>
              <Col xs="6" className="fr-skeleton-element" style={fareItem.title} />
              <Col xs="4" className="fr-skeleton-element" style={fareItem.button} />
            </Box>
          </Box>
        </Col>
      </Row>
      <Row gutters style={loadMore.main}>
        <Box style={loadMore.box} className="fr-skeleton-element" />
      </Row>
      <Row gutters>
        <Col xs="8">
          <Box className="fr-skeleton-element" style={disclaimer} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Col xs="12" className="fr-skeleton-element" style={AccordionHeading} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Col xs="12" className="fr-skeleton-element" style={AccordionHeading} />
        </Col>
      </Row>
    </Box>
  );
};

SkeletonBreakingDeals.componentName = 'SkeletonBreakingDeals';

export default SkeletonBreakingDeals;
